import React from 'react';

const Footer = ({ language }) => {
    const translations = {
        copyright: {
            zh: '版权所有 © 2023 内容分享平台',
            en: 'Copyright © 2023 Content Sharing Platform'
        },
        rights: {
            zh: '保留所有权利',
            en: 'All rights reserved'
        }
    };

    return (
        <footer className="bg-dark text-light py-4 mt-5">
            <div className="container">
                <div className="row">
                    <div className="col-md-6">
                        <p className="mb-0">{translations.copyright[language]}</p>
                        <p className="small text-muted">{translations.rights[language]}</p>
                    </div>
                    <div className="col-md-6 text-md-end">
                        <div className="social-links">
                            <a href="#" className="text-light me-3"><i className="bi bi-facebook"></i></a>
                            <a href="#" className="text-light me-3"><i className="bi bi-twitter"></i></a>
                            <a href="#" className="text-light me-3"><i className="bi bi-instagram"></i></a>
                            <a href="#" className="text-light"><i className="bi bi-linkedin"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer; 